"use strict";
var Observable_1 = require('../../Observable');
var first_1 = require('../../operator/first');
Observable_1.Observable.prototype.first = first_1.first;
//# sourceMappingURL=first.js.map


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/rxjs/add/operator/first.js
// module id = 254
// module chunks = 1